import { render } from "./EditPaper.vue?vue&type=template&id=3af215ef"
import script from "./EditPaper.vue?vue&type=script&lang=js"
export * from "./EditPaper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__